import styled from 'styled-components';
import {device} from 'styled/device';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.p`
  width: 300px;
`;

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const CopyIcon = styled.img`
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export const SocialNetWorkShareBtn = styled.div.attrs({
  className: 'share-link-modal__btn',
})`
  margin-bottom: 18px;
  background: #ffffff;
  border: 1px solid #393abd;
  border-radius: 9px;
  width: 100%;
  padding: 9px;
  color: #393abd;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.4s;

  &:hover {
    transition: all 0.4s;
    color: #fff;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
      radial-gradient(50% 50% at 50% 50%, #5573ff 0%, #4441e9 100%);
    box-shadow: none;
    opacity: 0.85;
  }
`;

export const Wrapper = styled.div`
  text-align: center;
  width: 100%;
`;

export const OrShareWithText = styled.div`
  margin-bottom: 24px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.15px;
  color: #152946;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.36px;
  color: #152946;
  margin-bottom: 24px;

  @media (min-width: ${device.tablet}) {
    font-size: 18px;
  }
`;

export const LinkCopiedText = styled.div`
  font-size: 14px;
  margin-top: 5px;
  position: absolute;
  color: #15cd72;
  right: 0;
`;
